import { z } from "zod";

import { isAdwSchema } from "@/src/models/common-schema";
import { OtherDocumentType } from "@/src/models/constants/document-types";
import { DatabaseDefaults } from "@/src/models/database-defaults";
import { DocumentDateSchema } from "@/src/models/documents/document-dates";
import { Patient, patientSchema } from "@/src/models/patient";
import { Practitioner, practitionerSchema } from "@/src/models/practitioner";

export const otherTypeDisplay: Record<OtherDocumentType, string> = {
  [OtherDocumentType.OTHER]: "Other",
};

export const otherSchema = z.object({
  isAdw: isAdwSchema,
  patient: patientSchema,
  dateReceived: DocumentDateSchema.shape.dateReceived,
  documentType: z.string().nullable(),
  signatureRequired: z.boolean().nullable(),
  receivingProvider: practitionerSchema.nullable(),
});

export type Other = Omit<z.infer<typeof otherSchema>, "patient" | "receivingProvider"> & {
  patient: Patient | null;
  receivingProvider: Practitioner | null;
} & DatabaseDefaults;

export const otherShape: Other = {
  id: "",
  isAdw: null,
  patient: null,
  dateReceived: null,
  documentType: null,
  signatureRequired: null,
  receivingProvider: null,
  createdAt: "",
  updatedAt: "",
  deletedAt: null,
  groupId: "",
};
